module.exports = __webpack_public_path__ + "81d00f2dbeb1d2fb5b524ef022670452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-30.jpg
// module id = 1172
// module chunks = 0